import "./menuComponent.scss";
import React from "react";
import { Link } from "react-router-dom";

const MenuComponent = () => {
  return (
    <section className="promo-banner promo-banner--menu" aria-label="Меню бара и кухни">
      <div className="promo-banner__bg" aria-hidden="true" />
      <div className="promo-banner__inner container">
        <div className="promo-banner__copy">
          <p className="section-label promo-banner__eyebrow">Бар и кухня</p>
          <h2 className="promo-banner__title">Меню в формате подачи в клубе</h2>
          <p className="promo-banner__text">
            Полные страницы меню — открывайте на телефоне или планшете перед
            визитом.
          </p>
        </div>
        <Link className="promo-banner__btn" to="/menu">
          Открыть меню
        </Link>
      </div>
    </section>
  );
};

export default MenuComponent;
